import { render, staticRenderFns } from "./AdminPanel.vue?vue&type=template&id=72f5b746&scoped=true&"
import script from "./AdminPanel.vue?vue&type=script&lang=ts&"
export * from "./AdminPanel.vue?vue&type=script&lang=ts&"
import style0 from "./AdminPanel.vue?vue&type=style&index=0&id=72f5b746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f5b746",
  null
  
)

export default component.exports